/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeDepositBoxFields } from './SafeDepositBoxFields';
import {
    SafeDepositBoxFieldsFromJSON,
    SafeDepositBoxFieldsFromJSONTyped,
    SafeDepositBoxFieldsToJSON,
    SafeDepositBoxFieldsToJSONTyped,
} from './SafeDepositBoxFields';
import type { SafeDepositBoxServiceRoleBulkItem } from './SafeDepositBoxServiceRoleBulkItem';
import {
    SafeDepositBoxServiceRoleBulkItemFromJSON,
    SafeDepositBoxServiceRoleBulkItemFromJSONTyped,
    SafeDepositBoxServiceRoleBulkItemToJSON,
    SafeDepositBoxServiceRoleBulkItemToJSONTyped,
} from './SafeDepositBoxServiceRoleBulkItem';

/**
 * 
 * @export
 * @interface SafeDepositBoxBulkSyncRequest
 */
export interface SafeDepositBoxBulkSyncRequest {
    /**
     * 
     * @type {SafeDepositBoxFields}
     * @memberof SafeDepositBoxBulkSyncRequest
     */
    safeDepositBoxDetails?: SafeDepositBoxFields;
    /**
     * 
     * @type {Array<SafeDepositBoxServiceRoleBulkItem>}
     * @memberof SafeDepositBoxBulkSyncRequest
     */
    serviceRoles: Array<SafeDepositBoxServiceRoleBulkItem>;
}

/**
 * Check if a given object implements the SafeDepositBoxBulkSyncRequest interface.
 */
export function instanceOfSafeDepositBoxBulkSyncRequest(value: object): value is SafeDepositBoxBulkSyncRequest {
    if (!('serviceRoles' in value) || value['serviceRoles'] === undefined) return false;
    return true;
}

export function SafeDepositBoxBulkSyncRequestFromJSON(json: any): SafeDepositBoxBulkSyncRequest {
    return SafeDepositBoxBulkSyncRequestFromJSONTyped(json, false);
}

export function SafeDepositBoxBulkSyncRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxBulkSyncRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'safeDepositBoxDetails': json['safeDepositBoxDetails'] == null ? undefined : SafeDepositBoxFieldsFromJSON(json['safeDepositBoxDetails']),
        'serviceRoles': ((json['serviceRoles'] as Array<any>).map(SafeDepositBoxServiceRoleBulkItemFromJSON)),
    };
}

export function SafeDepositBoxBulkSyncRequestToJSON(json: any): SafeDepositBoxBulkSyncRequest {
    return SafeDepositBoxBulkSyncRequestToJSONTyped(json, false);
}

export function SafeDepositBoxBulkSyncRequestToJSONTyped(value?: SafeDepositBoxBulkSyncRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'safeDepositBoxDetails': SafeDepositBoxFieldsToJSON(value['safeDepositBoxDetails']),
        'serviceRoles': ((value['serviceRoles'] as Array<any>).map(SafeDepositBoxServiceRoleBulkItemToJSON)),
    };
}

